import * as React from "react"
import { Check } from "lucide-react"
import { cn } from "../../lib/utils"

// Shadcn-like Checkbox matching Figma design
const Checkbox = React.forwardRef(({ id, checked, onCheckedChange, disabled, className, labelClassName, isDark, ...props }, ref) => {
  return (
    <label htmlFor={id} className={cn("inline-flex items-center cursor-pointer", disabled && "opacity-50 cursor-not-allowed", labelClassName)}>
      <input
        id={id}
        ref={ref}
        type="checkbox"
        className="sr-only"
        checked={!!checked}
        onChange={(e) => onCheckedChange && onCheckedChange(e.target.checked)}
        disabled={disabled}
        {...props}
      />
      <span
        aria-hidden
        className={cn(
          "inline-flex items-center justify-center h-[12px] w-[12px] rounded-[2px] transition-colors select-none",
          checked 
            ? "bg-[#cd6d2c]" 
            : isDark 
              ? "bg-transparent" 
              : "bg-white",
          className
        )}
        style={{ border: '1px solid #CD6D2C' }}
      >
        {checked && (
          <Check className={cn(
            "h-[14px] w-[14px] stroke-[3] transition-colors",
            isDark ? "text-black" : "text-white"
          )} />
        )}
      </span>
    </label>
  )
})

Checkbox.displayName = "Checkbox"

export { Checkbox }


